import { isObject } from './basicGuards.js';
import { getNumberErrors, getNonEmptyStringErrors, getOptionalErrors, getTimeZoneDateErrors } from './helpers.js';
import { getKeyValidationErrors } from './validation.js';

const locationObjectValidationKeys = {
  lat: getNumberErrors,
  lng: getNumberErrors,
  formattedAddress: getNonEmptyStringErrors
};
const realTimeLocationObjectValidationKeys = {
  lat: getNumberErrors,
  lng: getNumberErrors,
  formattedAddress: getNonEmptyStringErrors,
  lastUpdate: getOptionalErrors(getTimeZoneDateErrors)
};
/**
 * Validates that a location object appears not to be an empty initial
 * location object (`formattedAddress` must not be an empty string.)
 */

const isLocationObjectValid = locationObject => !getKeyValidationErrors(locationObject, locationObjectValidationKeys);
/**
 * Returns error string if a location object appears not to be an empty initial
 * location object (`formattedAddress` must not be an empty string.)
 */

const getLocationObjectErrors = value => {
  if (isObject(value)) {
    return getKeyValidationErrors(value, locationObjectValidationKeys);
  }

  return `Expected object, found ${typeof value}`;
};
const getRealTimeLocationObjectErrors = value => {
  if (isObject(value)) {
    return getKeyValidationErrors(value, realTimeLocationObjectValidationKeys);
  }

  return `Expected object, found ${typeof value}`;
};

export { getLocationObjectErrors, getRealTimeLocationObjectErrors, isLocationObjectValid };
